import React, { useState, createContext, useContext } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import CardGallery from './components/CardGallery';
import News from './components/News';
import NewsDetail from './components/NewsDetail';
import Events from './components/Events';
import About from './components/About';
import Footer from './components/Footer';
import CardsPage from './components/CardsPage';
import Collab from './components/Collab';
import './styles/App.css';

export const ThemeContext = createContext();

export const useTheme = () => useContext(ThemeContext);

// Home Page Component
const HomePage = () => {
  return (
    <>
      <Hero />
      <CardGallery />
      <News />
      <Events />
      <Collab />
      <About />
    </>
  );
};

function App() {
  const [darkMode, setDarkMode] = useState(false);

  const toggleTheme = () => {
    setDarkMode(!darkMode);
  };

  return (
    <ThemeContext.Provider value={{ darkMode, toggleTheme }}>
      <Router>
        <div className={`app ${darkMode ? 'dark-mode' : 'light-mode'}`}>
          <div className="comic-bg-overlay"></div>
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/cards" element={<CardsPage />} />
              <Route path="/news/:id" element={<NewsDetail />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </ThemeContext.Provider>
  );
}

export default App;
